import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router/router';
import '@/assets/styles/utils/style.scss';
import '@/assets/styles/pwa.scss';
import VCalendar from 'v-calendar';
import VueDatePicker from '@vuepic/vue-datepicker';
import 'v-calendar/style.css';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@vuepic/vue-datepicker/dist/main.css';
import { createPinia } from 'pinia';
import { setupGlobalErrorHandler } from '@/plugins/globalErrorHandler';
import svg4everybody from 'svg4everybody';
import MobileDetectionPlugin from '@/plugins/mobileDetection';
import { MOBILE_VIEW_THRESHOLD } from '@/common/lib/constant';
import visibility from '@/common/directives/visibility';
import Vue3Toastify from 'vue3-toastify';
import AuthMiddleware from '@/router/auth.middleware';
import useLoadingStore from '@/store/loading';
import setDirectives from '@/common/directives';
import { registerServiceWorker, setupPWAInstallPrompt, setupStatusBarStyling } from '@/plugins/pwa';

const app = createApp(App);
export const pinia = createPinia();

// PWA Setup
registerServiceWorker();
setupPWAInstallPrompt();
setupStatusBarStyling();

svg4everybody();
setDirectives(app);
setupGlobalErrorHandler(app);

app.directive('visibility', visibility);

app.component('VueDatePicker', VueDatePicker);

app
  .use(pinia)
  .use(Vue3Toastify)
  .use(VCalendar, {})
  .use(MobileDetectionPlugin, { thresholdWidth: MOBILE_VIEW_THRESHOLD });

// Reset loading state
const loadingStore = useLoadingStore();
loadingStore.resetLoadingState();

// Prevent zoom on mobile devices
if (window.innerWidth <= 768) {
  // Prevent zoom on double tap
  let lastTouchEnd = 0;
  document.addEventListener('touchend', function (event) {
    const now = (new Date()).getTime();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, false);

  // Prevent zoom on input focus
  document.addEventListener('focusin', function(event) {
    if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement || event.target instanceof HTMLSelectElement) {
      // Set viewport to prevent zoom
      const viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover');
      }
    }
  });

  // Restore viewport after input blur
  document.addEventListener('focusout', function(event) {
    if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement || event.target instanceof HTMLSelectElement) {
      setTimeout(() => {
        const viewport = document.querySelector('meta[name="viewport"]');
        if (viewport) {
          viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover');
        }
      }, 100);
    }
  });
}

AuthMiddleware(router);

app.use(router);
app.mount('#app');
